import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { Grid } from 'react-bootstrap';

import ClientsClass from '../../../clients/ClientsClass';
import { AppConstants } from '../../../constants';
import { ILoanAccount } from '../../../interfaces';

import LoanDocuments from '../common/LoanDocuments';

const { PERMISSIONS } = AppConstants;

interface IProps {
  loanAccount: ILoanAccount;
}

interface IInjected extends IProps {
  Clients: ClientsClass;
}

/**
 * The account's own documents -- the master agreement and anything else filed against the account
 * rather than against one loan on it. A single loan's documents live on the loan detail modal.
 */
@inject('Clients')
@autoBindMethods
@observer
class TabDocuments extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  public render () {
    const { loanAccount } = this.props
      , { Clients } = this.injected
      ;

    return (
      <Grid fluid className='loan-account-detail-tab tab-documents'>
        <LoanDocuments
          addPermission={PERMISSIONS.ADD_LOAN_ACCOUNT_DOCUMENT}
          client={Clients.loanAccountDocuments}
          deletePermission={PERMISSIONS.DELETE_LOAN_ACCOUNT_DOCUMENT}
          editPermission={PERMISSIONS.EDIT_LOAN_ACCOUNT_DOCUMENT}
          parent={{ account: loanAccount.id }}
          title='Account Documents'
        />
      </Grid>
    );
  }
}

export default TabDocuments;
